import React, { useState } from 'react';
import { Container, Button, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BsChatDots, BsMap, BsHouseDoor, BsCalculator, BsPerson, BsArrowRight } from 'react-icons/bs';
import KairosLogo from '../../../assets/img/logos/KairosIQLogov2.jpg';
import './NavigationHeader.css';

interface NavigationHeaderProps {
  tenant?: any;
  branding?: any;
  isWhiteLabel?: boolean;
}

const NavigationHeader: React.FC<NavigationHeaderProps> = ({ tenant, branding, isWhiteLabel }) => {
  const navigate = useNavigate();
  const [showExplore, setShowExplore] = useState(false);

  const handleMapSearchClick = () => {
    // Navigate to customer portal search view
    navigate('/search');
  };

  const handleChatSearchClick = () => {
    navigate('/chat');
  };

  return (
    <nav className="chat-nav enhanced">
      <Container>
        <div className="nav-content">
          <div className="brand">
            <h1 onClick={() => navigate('/')}>
              <BsChatDots className="brand-icon" />
              {isWhiteLabel && tenant ? tenant.companyName : 'Chat.RealEstate'}
            </h1>
            <span className="brand-tagline">
              {isWhiteLabel && tenant ? tenant.tagline : 'AI-Powered Property Search'}
            </span>
          </div>
          
          <div className="nav-links">
            {/* Explore Dropdown */}
            <div 
              className="nav-item-wrapper"
              onMouseEnter={() => setShowExplore(true)}
              onMouseLeave={() => setShowExplore(false)}
            >
              <a href="#" className="nav-link-enhanced">
                Explore
                <div className={`dropdown-panel ${showExplore ? 'show' : ''}`}>
                  <div className="dropdown-grid">
                    <div className="dropdown-item" onClick={handleChatSearchClick}>
                      <BsChatDots className="dropdown-icon" />
                      <div>
                        <h5>Chat Search</h5>
                        <p>Talk naturally about what you're looking for</p>
                      </div>
                    </div>
                    <div className="dropdown-item" onClick={handleMapSearchClick}>
                      <BsMap className="dropdown-icon" />
                      <div>
                        <h5>Property Search</h5>
                        <p>Explore properties visually on interactive map</p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <a href="/home-value" className="nav-link-enhanced">
              <BsCalculator className="me-1" />
              Home Value
            </a>
            
            <a href="/find-agent" className="nav-link-enhanced">
              <BsPerson className="me-1" />
              Find Agent
            </a>

            <div className="nav-divider"></div>

            {/* CTA Buttons */}
            <Button
              variant="outline-primary"
              size="sm"
              className="nav-btn-outline"
              onClick={() => navigate('/sign-up')}
            >
              Sign In
            </Button>
            
            <Button
              variant="primary"
              size="sm"
              className="nav-btn-primary"
              onClick={handleMapSearchClick}
            >
              Start Searching
              <BsArrowRight className="ms-1" />
            </Button>
          </div>
          
          {/* KairosIQ AI Realty Logo - Far Right */}
          <img 
            src={KairosLogo} 
            alt="KairosIQ AI Realty" 
            style={{ 
              height: '45px',
              marginLeft: '20px',
              objectFit: 'contain'
            }}
          />
        </div>
      </Container>
    </nav>
  );
};

export default NavigationHeader;